import { Controller } from "@hotwired/stimulus"
import gsap from "gsap"

export default class extends Controller {
  static targets = ["word"]
  static values = {
    words: Array,
    interval: { type: Number, default: 2500 },
    firstInterval: { type: Number, default: 800 },
  }

  connect() {
    this.index = 0
    this.wordTarget.textContent =
      this.wordsValue[0]
    this.timer = setTimeout(
      () => this.firstRotate(),
      this.firstIntervalValue
    )
  }

  disconnect() {
    clearTimeout(this.timer)
    clearInterval(this.timer)
  }

  firstRotate() {
    this.rotate()
    this.timer = setInterval(
      () => this.rotate(),
      this.intervalValue
    )
  }

  rotate() {
    const el = this.wordTarget
    const next =
      (this.index + 1) % this.wordsValue.length

    gsap.to(el, {
      y: "-100%",
      autoAlpha: 0,
      duration: 0.3,
      ease: "power2.in",
      onComplete: () => {
        this.index = next
        el.textContent =
          this.wordsValue[this.index]
        gsap.set(el, { y: "100%" })
        gsap.to(el, {
          y: "0%",
          autoAlpha: 1,
          duration: 0.3,
          ease: "power2.out",
        })
      },
    })
  }
}
